module.exports = __webpack_public_path__ + "static/media/bg.b9a11432.png";